import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as api from './SetupApi';
import { SetupAccountRequest } from './SetupTypes';

export function useSetupAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: SetupAccountRequest) => api.setupAccount(request),
    onSuccess: () => queryClient.resetQueries(),
  });
}
